module.exports = __webpack_public_path__ + "static/media/attribute_melee_normal.bb152cf1.png";